// extracted by mini-css-extract-plugin
module.exports = {"box":"suggestion_box__2CDKl","box__list":"suggestion_box__list__2QdTY","box__list__span":"suggestion_box__list__span__2O9WX","box__list__item":"suggestion_box__list__item__3JRxa"};